import implementConstants from './implement';

const { STATUS_ASSIGNMENT_STATUS } = implementConstants;

const DEFAULT_PARAMS_REGIONAL_ADMIN = {
  assignedType: STATUS_ASSIGNMENT_STATUS.ALL.value,
};

export default {
  DEFAULT_PARAMS_REGIONAL_ADMIN,
};
